var scope_0 = require('/workspaces/terrykwon.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a8e946638900d3c42a905aaec6e3ea45.js').default;
var scope_1 = require('/workspaces/terrykwon.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/workspaces/terrykwon.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f1ce650745baaf40131631f44ae896c8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    